import { Data, Effect, Either } from "effect";

export class RiskQueryRequestError extends Data.TaggedError(
  "RiskQueryRequestError",
)<{
  readonly cause: unknown;
}> {}

/** Keeps contract failures intact and gives rejected setup/defects a typed error. */
export async function runRiskQuery<A, E>(
  intent: () => Promise<Effect.Effect<A, E>>,
): Promise<Either.Either<A, E | RiskQueryRequestError>> {
  try {
    return await Effect.runPromise(Effect.either(await intent()));
  } catch (cause) {
    return Either.left(new RiskQueryRequestError({ cause }));
  }
}
